@if (loading$ | async) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
} @else {
  <div class="bg-white px-4 py-10">
    @if (authQuery.name$ | async; as name) {
      <div class="flex justify-between">
        @if (cardUsers$ | async; as user) {
          <div class="grid">
            <div class="aux-black mb-1 text-3xl font-bold">Welcome, {{ name }}</div>
            @if (user[0].sponsor_organization) {
              <div class="aux-gray-dark-100 text-lg">
                {{ user[0].sponsor_organization.name }}
              </div>
            }
          </div>
        }
        @if (trials$) {
          <div class="flex items-center">
            @if ((loadingRefreshPortfolioDashboard$ | async) === true) {
              <div class="mr-2 flex h-auto">
                <div class="spinner h-9 w-9"></div>
              </div>
            }

            @if ((loadingRefreshPortfolioDashboard$ | async) === false) {
              <div class="mr-2 h-auto">
                @if ((quicksight_dashboard_portfolio$ | async) === false || isReviewApp === true) {
                  <button class="btn--secondary pl-3" (click)="triggerRefreshPortfolioDashboard()">
                    <aux-icon name="CloudDownload" class="mr-2" />
                    Refresh
                  </button>
                }
              </div>
            }

            @if ((quicksight_dashboard_portfolio$ | async) === false || isReviewApp === true) {
              <aux-export-excel-button
                [gridAPI]="gridAPI"
                [excelOptions]="excelOptions"
                [getDynamicExcelParamsCallback]="getDynamicExcelParams.bind(this)"
                pendoTag="portfolio-dashboard-excel-export-button"
              />
            }
            <aux-trial-dropdown
              [trials$]="trials$"
              [trialFormControl]="trialFc"
              [className]="'ml-2 h-auto'"
              [mainPage]="false"
            />
          </div>
        }
      </div>
    }
  </div>

  @if ((quicksight_dashboard_portfolio$ | async) === false || isReviewApp === true) {
    <div class="bg-aux-gray-light">
      <div class="xl:border-b"></div>

      <section class="mx-7 my-4 grid grid-cols-3 gap-4">
        <div
          [ngClass]="{
            'col-span-2': (showTaskSection$ | async) === true,
            'col-span-3': (showTaskSection$ | async) === false,
          }"
        >
          <div class="mb-4 flex justify-items-stretch border-l-8 border-aux-blue-dark bg-white">
            @if (cardValues | async; as val) {
              <div class="w-full border-aux-gray-dark p-2 xl:border-b xl:border-r xl:border-t">
                <div class="grid w-full grid-cols-7 gap-y-4 bg-white pb-4 pt-4">
                  <div class="flex">
                    <div class="grid w-full">
                      <div class="text-sm text-aux-black">Total Current (LRE)</div>
                      <div class="text-xl text-aux-black">{{ val.clre | money }}</div>
                    </div>
                  </div>

                  <div class="flex justify-center">
                    <div class="border-r"></div>
                  </div>

                  <div class="flex">
                    <div class="grid w-full">
                      <div class="text-sm text-aux-black">Total Baseline</div>
                      <div class="text-xl text-aux-black">{{ val.base | money }}</div>
                    </div>
                  </div>

                  <div class="flex justify-center">
                    <div class="border-r"></div>
                  </div>

                  <div class="flex">
                    <div class="grid w-full items-center">
                      <div class="text-sm text-aux-black">Variance ($)</div>
                      @if (val.var_cost > 0) {
                        <div class="flex items-center text-xl text-aux-black">
                          {{ val.var_cost | money }}
                          <aux-icon name="CircleArrowUpFilled" class="ml-1 text-aux-error" />
                        </div>
                      } @else if (val.var_cost < 0) {
                        <div class="flex items-center text-xl text-aux-black">
                          {{ val.var_cost * -1 | money }}
                          <aux-icon name="CircleArrowDownFilled" class="ml-1 text-aux-green" />
                        </div>
                      } @else {
                        <div class="items-center text-center text-xl text-aux-black">—</div>
                      }
                    </div>
                  </div>

                  <div class="flex justify-center">
                    <div class="border-r"></div>
                  </div>

                  <div class="flex">
                    <div class="grid w-full items-center">
                      <div class="text-sm text-aux-black">Variance (%)</div>
                      @if (val.var_cost > 0) {
                        <div class="flex items-center text-xl text-aux-black">
                          {{ (val.var_cost / val.base) * 100 | number: '1.2-2' }}%
                          <aux-icon name="CircleArrowUpFilled" class="ml-1 text-aux-error" />
                        </div>
                      } @else if (val.var_cost < 0) {
                        <div class="flex items-center text-xl text-aux-black">
                          {{ (val.var_cost / val.base) * -100 | number: '1.2-2' }}%
                          <aux-icon name="CircleArrowDownFilled" class="ml-1 text-aux-green" />
                        </div>
                      } @else {
                        <div class="items-center text-center text-xl text-aux-black">—</div>
                      }
                    </div>
                  </div>

                  <div class="flex">
                    <div class="grid w-full">
                      <div class="text-sm text-aux-black">Expense LTD</div>
                      <div class="text-xl text-aux-black">{{ val.wpltd | money }}</div>
                    </div>
                  </div>

                  <div class="flex justify-center">
                    <div class="border-r"></div>
                  </div>

                  <div class="flex">
                    <div class="grid w-full">
                      <div class="text-sm text-aux-black">Invoiced Total</div>
                      <div class="text-xl text-aux-black">{{ val.invoiced | money }}</div>
                    </div>
                  </div>

                  @if ((section_portfolio_analytics_avg_month_close$ | async) === true) {
                    <div class="flex justify-center">
                      <div class="border-r"></div>
                    </div>
                  }

                  @if ((section_portfolio_analytics_avg_month_close$ | async) === true) {
                    <div class="flex">
                      <div class="grid w-full">
                        <div class="text-sm text-aux-black">Avg. Month Close</div>
                        <div class="text-xl text-aux-black">12 Days</div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <div class="flex justify-items-stretch border-l-8 border-aux-blue-dark bg-white">
            @if (lineChart) {
              <div class="w-full border-aux-gray-dark xl:border-b xl:border-r xl:border-t">
                <div class="mt-2 grid">
                  <canvas
                    style="max-height: 600px; min-height: 400px"
                    baseChart
                    class="chart"
                    [type]="lineChart.type"
                    [data]="lineChart.data"
                    [options]="lineChart.options"
                  ></canvas>
                </div>
              </div>
            }
          </div>
        </div>
        @if (showTaskSection$ | async) {
          <div class="relative col-span-1 border-l-8 border-aux-blue-dark">
            <aux-portfolio-tasks class="absolute inset-0" />
          </div>
        }
      </section>

      <div class="mx-7 mb-16 mt-4 border-aux-gray-dark bg-aux-gray-light">
        <ag-grid-angular
          class="ag-theme-aux portfolio-grid w-full tabular-nums"
          [gridOptions]="(gridOptions$ | async)!"
          [rowData]="gridData$ | async"
          [domLayout]="'autoHeight'"
          [enableBrowserTooltips]="true"
          (gridReady)="onGridReady($event)"
          (window:resize)="autoSize()"
        />
      </div>
    </div>
  }

  @if ((quicksight_dashboard_portfolio$ | async) === true && isReviewApp === false) {
    <aux-quicksight-portfolio-dashboard />
  }
}
